import { Box, Text } from '@chakra-ui/react';
import ScheduleSlot from './ScheduleSlot';
const data = [
    {order: 1, title: 'Aca',bgcolor:'#6eb6c0',color:'#c53b7b' },
    { order: 2, title: 'Webbrain',bgcolor:'#fff9ef',color:'#d8961d' },
    { order: 3, title: 'Webbrain',bgcolor:"#fa5b59",color:'#6eb6c0' },
    { order: 4, title: 'Webbrain',bgcolor:'#edf5ff',color:'#1861bd' },
    { order: 5, title: 'Webbrain',bgcolor:"#fff9ef",color:'#d8961d' },
    { order: 6, title: 'Webbrain',bgcolor:'#6eb6c0',color:'#c53b7b' },
    { order: 7, title: 'Webbrain',bgcolor:"#fff9ef",color:'#d8961d' },
    { order: 8, title: 'Webbrain',bgcolor:'#fa5b59',color:'#6eb6c0' },
    { order: 9, title: 'Webbrain',bgcolor:"#edf5ff",color:'#1861bd' }, 
];
export default function ScheduleRow({ session, time, id }) {
  return (
    <Box
      width='100%'
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      mb='1rem'
      
    >
      <Box
        flex='1'
        display='flex'
        height='100px'
        justifyContent='center'
        alignItems='center'
        color='#F25C3A'
        style={{ fontFamily: 'Mulish, sans-serif' }}
      >
        <Text
          fontFamily='Poppins'
          fontStyle='normal'
          fontWeight='bold'
          fontSize='12px'
          lineHeight='18px'
          color='black'
          style={{ fontFamily: 'Mulish, sans-serif'  }}
        >
          {time}
        </Text>
      </Box>
      {session.map((row, idx) => (
        <ScheduleSlot
          key={idx}
          subject={row ? row.subject_name : null}
          className={row ? row.class_name : null}
          categoryId={row ? row.category_id : null}
          bgcolorName={data[idx]["bgcolor"]}
          colorName={data[idx]["color"]}
          time={time}
          libraryTitle={row ? row.library_title : null}
          contentUrl={row ? row.library_url : null}
        />
      ))}
    </Box>
  );
}
